export default __webpack_public_path__ + "static/media/usingApp.5a01f1fd.jpg";